@if (coupon$ | async; as coupon) {
  <div class="flex flex-col header mt-4 mb-4">
    <h1 class="text-2xl font-bold">{{'#COUPONS.REDEEM_PAGE.HEADER.TITLE' | translate }}</h1>
    <h3 class="text-lg font-bold color-light">{{coupon.code}}</h3>
    <div class="flex flex-row justify-between row-no-wrap header-info mt-3 mb-4">
      <p class="text-body pr-5 line-height">
        {{'#COUPONS.REDEEM_PAGE.HEADER.INFO.DESCRIPTION' | translate }}
      </p>
      <div class="header-info-amount">
        <p class="coupon-amount-overline light uppercased">{{'#COUPONS.REDEEM_PAGE.HEADER.INFO.BALANCE' | translate }}</p>
        <div class="coupon-amount">{{ coupon.balance || 0 | number:'1.2-2' }} EUR</div>
      </div>
    </div>
  </div>
  <div class="flex flex-col form-container charge space-bottom">
    <h3 class="headline-3">{{'#COUPONS.REDEEM_PAGE.FORM.TITLE' | translate }}</h3>
    <div class="flex flex-col suggestions mt-3 mb-3">
      <p class="formlabel weight-bold">{{'#COUPONS.REDEEM_PAGE.FORM.SUGGESTIONS.TITLE' | translate }}</p>
      <soft-chip-group class="flex flex-row">
        @for (amount of amounts | filter:amountFilter:coupon.balance; track amount; let i = $index) {
          <soft-chip
            class="mr-2 mt-2 pointer"
            (click)="select(i, coupon?.balance ?? 0); input.value = ''"
            [class.selected]="i === selectedIndex">
            {{amount | number:'1.2-2'}} EUR
          </soft-chip>
        }
        <soft-chip
          class="mr-2 mt-2 pointer"
          (click)="selectAvailable(coupon?.balance ?? 0); input.value = ''"
          [class.selected]="selectedIndex === amounts.length"
          >
          {{ '#COUPONS.REDEEM_PAGE.FORM.DEBIT_FULL' | translate }}
        </soft-chip>
      </soft-chip-group>
    </div>
    <div class="flex flex-col manual-input mt-3 mb-5">
      <p class="formlabel weight-bold">{{'#COUPONS.REDEEM_PAGE.FORM.MANUAL_INPUT.TITLE' | translate }}</p>
      <div class="flex flex-row manual-input-container soft-input mt-1 mb-1">
        <input type="number"
          id="manual-amount-input"
          [placeholder]="'#COUPONS.REDEEM_PAGE.FORM.MANUAL_INPUT.PLACEHOLDER' | translate"
          (input)="setAmount(+input.value, coupon?.balance ?? 0); resetChips()" #input>
      </div>
      @if (+input.value > coupon.balance) {
        <div class="soft-property-validation">
          <soft-validation-message [message]="{type: 'error', subject: '#COUPONS.REDEEM_PAGE.FORM.MANUAL_INPUT.ERROR', message: ''}"></soft-validation-message>
        </div>
      }
    </div>
  </div>
  <div class="flex flex-col items-center viewer-section space-bottom">
    <p class="text-body light">{{'#COUPONS.REDEEM_PAGE.SELECTED_SECTION.HEADING_AMOUNT' | translate }}</p>
    <div class="selection-large">{{ selectedAmount || 0 | number:'1.2-2' }} EUR</div>
    <p class="text-body">{{'#COUPONS.REDEEM_PAGE.SELECTED_SECTION.SALDO_DESCRIPTION' | translate }} <span style="color: darkred;">{{ (coupon?.balance || 0) - selectedAmount | number:'1.2-2' }}</span></p>
  </div>
  <div class="flex flex-row row-no-wrap button-section mt-5 fixed-footer">
    <button class="soft-button secondary custom-size custom-button" (click)="cancelRedeem()">{{'#COUPONS.REDEEM_PAGE.BUTTONS.CANCEL' | translate }}</button>
    <button
      class="soft-button primary custom-size custom-button"
      [disabled]="selectedAmount <= 0 || +input.value > coupon.balance"
    (click)="redeem()">{{'#COUPONS.REDEEM_PAGE.BUTTONS.REDEEM' | translate }}</button>
  </div>
}
